import * as React from 'react';
import {defineMessage} from 'react-intl';
import {setup, run} from '../../snippets/node';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  customer: {},
  'pass-customer': {},
  charge: {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.node.run-server',
        defaultMessage:
          'Run your Node server and go to <a>localhost:4242/checkout.html</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242/checkout.html" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand(run),
  },
};

export default ({keys, merchant}) => `const express = require("express");
const app = express();
{+setup}
${comment && comment(merchant)}
const stripe = require("stripe")("${keys.secret}");
{/setup}

app.use(express.static("public"));
app.use(express.json());

const calculateOrderAmount = items => {
  // Replace this constant with a calculation of the order's amount
  // Calculate the order total on the server to prevent
  // people from directly manipulating the amount on the client
  return 1400;
};

{?save-card charge}
const chargeCustomer = async (customerId) => {
  // Lookup the payment methods available for the customer
  const paymentMethods = await stripe.paymentMethods.list({
    customer: customerId,
    type: "card"
  });

  // Charge the customer and payment method immediately
  const paymentIntent = await stripe.paymentIntents.create({
    amount: 1099,
    currency: "usd",
    customer: customerId,
    payment_method: paymentMethods.data[0].id,
    off_session: true,
    confirm: true
  });

  if (paymentIntent.status === "succeeded") {
    console.log("✅ Successfully charged card off session");
  }
}

{/charge}
app.post("/create-payment-intent", async (req, res) => {
  const { items } = req.body;
  {?save-card customer}
  // Alternatively, set up a webhook to listen for the payment_intent.succeeded event
  // and attach the PaymentMethod to a new Customer
  const customer = await stripe.customers.create();
  {/customer}
  {+create}
  // Create a PaymentIntent with the order amount and currency
  const {span response create}paymentIntent{/span} = await stripe.paymentIntents.create({
    {?save-card pass-customer}
    customer: customer.id,
    setup_future_usage: 'off_session',
    {/pass-customer}
    amount: calculateOrderAmount(items),
    currency: "usd"
  });

  res.send({
    clientSecret: paymentIntent.client_secret
  });
  {/create}
});

app.listen(4242, () => console.log('Node server listening on port 4242!'));
`;
